import { z } from 'zod';
import { email, password, phoneE164, locale } from './common.js';
/** Cliente que está logando: 'web' recebe o refresh em cookie; 'mobile' recebe `refreshToken` no corpo (sessão MOBILE). */
export const authClient = z.enum(['web', 'mobile']).optional();
export const loginSchema = z.object({ email, password, client: authClient });
/** Refresh/logout do app: o refresh token vem no corpo (a web usa o cookie e não envia nada). */
export const refreshBodySchema = z.object({ refreshToken: z.string().min(32).max(200).optional() });
/** Dispositivo do app para push (FCM). Um token por dispositivo; o mesmo token reenviado só atualiza. */
export const registerDeviceSchema = z.object({
    token: z.string().min(20).max(4096),
    platform: z.enum(['ios', 'android']),
    locale: locale.optional(),
    appVersion: z.string().trim().max(40).optional(),
    deviceName: z.string().trim().max(120).optional(),
});
export const acceptInviteSchema = z.object({
    token: z.string().min(16),
    /** Obrigatório para conta nova; ignorado quando o e-mail já tem conta (aí `password` é a senha atual). */
    name: z.string().trim().min(2).max(120).optional(),
    password,
    /** Qualquer formato; normalizado para E.164 na API. */
    phone: z.string().trim().max(32).optional(),
});
export const forgotPasswordSchema = z.object({ email });
export const resetPasswordSchema = z.object({ token: z.string().min(16), password });
export const updateProfileSchema = z.object({
    name: z.string().trim().min(2).max(120).optional(),
    phone: phoneE164.nullable().optional(),
    locale: locale.optional(),
    theme: z.enum(['light', 'dark', 'system']).optional(),
});
export const changePasswordSchema = z.object({ currentPassword: password, newPassword: password });
export const adminMfaVerifySchema = z.object({
    code: z.string().trim().min(6).max(12),
});
export const adminMfaEnrollConfirmSchema = z.object({ code: z.string().trim().length(6) });
//# sourceMappingURL=auth.js.map